import {getData} from "../api/get-data";

export const setAuthPass = (login, password, resolveHandler, rejectHanlder) => {
  getData({
    [`set_auth_pass`]: {
      [`auth_login`]: login,
      [`auth_pass`]: password,
    }
  })
  .then((response) => {
    if (response.result === `OK`) {
      resolveHandler();
    }
    if (response.result === `ERROR`) {
      rejectHanlder(response.error);
    }
  })
  .catch(() => {
    rejectHanlder();
  });
};
